import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useDataLayer from 'src/hooks/useDataLayer';
import {
  PriceOptionsLabelWrapper,
  FinanceOptionWrap,
  Price,
  PriceWrapper,
  InfoButton,
  FinanceButton,
  FinanceLabel,
} from 'components/Tray/Tray.styled.js';
import { DisclaimerTriangle } from 'components/Disclaimer/Disclaimer.styled';
import Disclaimer from 'components/Disclaimer/Disclaimer';
import Label from 'components/_utility/Label';
import InfoCircle from 'src/assets/icons/info-circle.svg';
import { openDisclaimer, closeDisclaimer, setSelectedDisclaimer } from 'src/redux/configurator/actions';
import { disclaimerTypeSelector, disclaimerOpenSelector } from 'src/redux/configurator/selectors';
import useOpenFinance from 'src/hooks/useOpenFinance';

const TrayTotal = ({ label, price, text, financeHidden, isScrolling }) => {
  const dispatch = useDispatch();
  const pushToDataLayer = useDataLayer();
  const openFinanceCalculator = useOpenFinance();

  const disclaimerType = useSelector(disclaimerTypeSelector);
  const disclaimerOpen = useSelector(disclaimerOpenSelector);

  const infoButtonRef = useRef();
  const financeOptionRef = useRef();

  const [infoButtonLeftPosition, setInfoButtonLeftPosition] = useState(0);
  const [financeOptionsLeftPosition, setFinanceOptionsLeftPosition] = useState(0);

  const setPositions = () => {
    setInfoButtonLeftPosition(infoButtonRef.current.getBoundingClientRect().left);

    setFinanceOptionsLeftPosition(financeOptionRef.current.getBoundingClientRect().left);
  };

  useEffect(() => {
    setPositions();

    window.addEventListener('resize', setPositions);

    return () => {
      window.removeEventListener('resize', setPositions);
    };
  }, []);

  const toggleDisclaimer = () => {
    if (disclaimerOpen) {
      dispatch(closeDisclaimer());
      dispatch(setSelectedDisclaimer(null));
    } else {
      dispatch(openDisclaimer());
      dispatch(setSelectedDisclaimer('price'));
    }
  };

  return (
    <FinanceOptionWrap ref={financeOptionRef}>
      {disclaimerType === 'price' && (
        <>
          <Disclaimer financeOptionsLeftPosition={financeOptionsLeftPosition} infoButtonRef={infoButtonRef}>
            {text}
          </Disclaimer>
          <DisclaimerTriangle infoButtonLeftPosition={infoButtonLeftPosition}></DisclaimerTriangle>
        </>
      )}
      <PriceWrapper>
        <InfoButton
          type="button"
          ref={infoButtonRef}
          onClick={() => [pushToDataLayer('configuratorPriceInfo'), toggleDisclaimer()]}
        >
          <InfoCircle />
        </InfoButton>
        <FinanceButton
          as={financeHidden ? 'div' : 'button'}
          onClick={() => (financeHidden ? {} : [pushToDataLayer('configuratorTrayFinance'), openFinanceCalculator()])}
        >
          <PriceOptionsLabelWrapper>
            {!isScrolling && <Label name={label} />}
            {/* <InfoButton
              type="button"
              ref={infoButtonRef}
              onClick={() => [pushToDataLayer('configuratorPriceInfo'), toggleDisclaimer()]}
              >
              <InfoCircle />
            </InfoButton> */}
          </PriceOptionsLabelWrapper>
          <Price>{price}</Price>
          {!financeHidden && !isScrolling && (
            <FinanceLabel>
              <Label name="calculateLabel"></Label>
            </FinanceLabel>
          )}
        </FinanceButton>
      </PriceWrapper>
    </FinanceOptionWrap>
  );
};

export default TrayTotal;
